import { Body, Controller, Post, UploadedFiles, UseInterceptors } from '@nestjs/common/decorators';
import { FilesInterceptor } from '@nestjs/platform-express';
import { ApiTags } from '@nestjs/swagger';
import { returnException } from '@project-management-system/backend-utils';
import { FeatureFilesReqModel, GlobalResponseObject, ReferenceFeatures } from '@project-management-system/shared-models';
import { diskStorage } from 'multer';
import { FileUploadIdReq } from './dto/file-upload-id.req';
import { FileHandlingService } from './file-handling.service';
import { extname } from 'path';

@ApiTags('file-handling')
@Controller('file-handling')
export class FileHandlingController {
  constructor(private fileHandlingService: FileHandlingService) { }

  @Post('deleteSingleFile')
  async deleteSingleFile(
    @Body() req: FileUploadIdReq
  ): Promise<GlobalResponseObject> {
    try {
      return await this.fileHandlingService.deleteSingleFile(req);
    } catch (error) {
      return returnException(GlobalResponseObject, error);
    }
  }

  @Post('getSavedFilesData')
  async getSavedFilesData(
    @Body() req: FeatureFilesReqModel
  ): Promise<GlobalResponseObject> {
    try {
      return await this.fileHandlingService.getSavedFilesData(
        req.featuresRefId,
        req.featuresRefName,
        true
      );
    } catch (error) {
      return returnException(GlobalResponseObject, error);
    }
  }

  @Post('getAllSavedFilesData')
  async getAllSavedFilesData(
    @Body() req: FeatureFilesReqModel
  ): Promise<GlobalResponseObject> {
    try {
      return await this.fileHandlingService.getSavedFilesData(
        req.featuresRefId,
        req.featuresRefName,
        true
      );
    } catch (error) {
      return returnException(GlobalResponseObject, error);
    }
  }

  

  @Post('/fileUpload')
  @UseInterceptors(FilesInterceptor('file', 10, {
    storage: diskStorage({
      destination: './upload_files',
      filename: (req, file, callback) => {
        const name = file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
        callback(null, `${name}-${randomName}${fileExtName}`);
      },
    }),
    fileFilter: (req, file, callback) => {
      if (!file.originalname.match(/\.(xlsx|xls|pdf|jpg|png|jpeg|doc|PDF|csv)$/)) {
        return callback(new Error('Only xlsx,xls,pdf, jpg, png, doc, jpeg files are allowed!'), false);
      }
      callback(null, true);
    },
  }))
  async fileUpload(@UploadedFiles() file: File[], @Body() uploadData: any): Promise<any> {
    try {
      return await this.fileHandlingService.save(file, uploadData.createdUser, uploadData.referenceFeatures, uploadData.id)
    } catch (error) {
      return returnException(GlobalResponseObject, error);
    }
  }

}
// function FilesInterceptor(arg0: string, arg1: number, arg2: { storage: any; fileFilter: (req: any, file: any, callback: any) => any; }): Function | import("@nestjs/common").NestInterceptor<any, any> {
//   throw new Error('Function not implemented.');
// }

// function diskStorage(arg0: {
//   // destination: './upload-files/manisha-123',
//   // destination: `./upload-files/PO-${req}`,
//   destination: (req: any, file: any, callback: any) => void;
//   // destination: (req, file, callback) => {
//   //   callback(null, `./upload-files/PO-${req.body.customerPo}`);
//   // },
//   filename: (req: any, file: any, callback: any) => void;
// }): any {
//   throw new Error('Function not implemented.');
// }

